import React, { useState } from "react";
import "../styles/components/Faq.css";
import Navigation from "../components/Navigation/Navigation.js";
import Footer from "./Footer.js";

const faqs = [
  {
    question: "How do I book a flight?",
    answer:
      "You can search for available flights using our search tool, select your preferred flight, and follow the simple booking process to complete your reservation."
  },
  {
    question: "Can I change or cancel my booking?",
    answer:
      "Yes, you can change or cancel your booking based on the airline's policies. Please log in to your account and navigate to 'Manage Bookings' to make changes."
  },
  {
    question: "How long does it take to receive a refund?",
    answer:
      "Refunds may take 7–14 business days to reflect in your account, depending on your payment provider and airline processing times."
  },
  {
    question: "Are there any service fees?",
    answer:
      "Flight Reservation Hub may charge a small service fee for booking management. Airline-specific charges may also apply."
  },
  {
    question: "Do I need to create an account to book a flight?",
    answer:
      "While you can search for flights without an account, creating one allows you to manage bookings, request refunds, and access exclusive deals."
  }
];

export default function Faq() {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      <Navigation />
      <div className="faq-container">
        <div className="faq-box">
          <h1>Frequently Asked Questions</h1>
          <p className="intro">
            Welcome to the <strong>Flight Reservation Hub</strong> FAQ section.  
            Here are answers to some of the most common questions our customers ask.
          </p>
          <div className="faq-list">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className={`faq-item ${activeIndex === index ? "active" : ""}`}
                onClick={() => toggleFAQ(index)}
              >
                <div className="faq-question">{faq.question}</div>
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
          <p className="faq-footer">
            Still have questions? Contact us at{" "}
            <a href="mailto:support@flightreservationhub.com">
              support@flightreservationhub.com
            </a>
          </p>
        </div>
      </div>
      <Footer/>
    </>
  );
}
